import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="section grid min-h-[60vh] place-items-center text-center">
      <div>
        <p className="font-display text-7xl font-extrabold text-gradient">404</p>
        <p className="mt-3 text-ink-300">This page wandered off to another event.</p>
        <Link to="/" className="btn-primary mt-6">Back Home</Link>
      </div>
    </div>
  );
}
